<template>
  <nav class="build-spoke-nav" aria-label="Build">
    <div class="spoke-inner">
      <router-link
        v-for="item in items"
        :key="item.to"
        :to="item.to"
        class="spoke-link"
        :class="{ active: isActive(item) }"
      >
        {{ item.label }}
      </router-link>
    </div>
  </nav>
</template>

<script>
/**
 * Build spoke local nav (hub-and-spoke).
 * Global rail only shows Build → this strip keeps tools reachable inside the spoke.
 * @see docs/product/HUB_SPOKE_PORTAL.md
 */
export default {
  name: 'BuildSpokeNav',
  computed: {
    path() {
      return this.$route.path;
    },
    items() {
      return [
        {
          to: '/build-management',
          label: 'Hub',
          match: (path) => path === '/build-management' || path === '/build-management/',
        },
        {
          to: '/construction-dashboard',
          label: 'Construction',
          match: (path) => path.startsWith('/construction-dashboard') || path.startsWith('/master-data-audit') || path.startsWith('/house-budget'),
        },
        {
          to: '/development-budgets',
          label: 'Budgets',
          match: (path) => path.startsWith('/development-budgets') || path.startsWith('/loan-draws'),
        },
        {
          to: '/house-pricing',
          label: 'Pricing',
          match: (path) => path.startsWith('/house-pricing'),
        },
        {
          to: '/construction-wip',
          label: 'WIP',
          match: (path) => path.startsWith('/construction-wip'),
        },
        {
          to: '/gap-resolution',
          label: 'Gaps',
          match: (path) => path.startsWith('/gap-resolution') || path.startsWith('/invoice-upload'),
        },
        {
          to: '/buyer-portal',
          label: 'Selections',
          match: (path) => path.startsWith('/buyer-portal'),
        },
        {
          to: '/wealth/equity-screens',
          label: 'Screens',
          match: (path) => path.startsWith('/wealth/equity-screens'),
        },
      ];
    },
  },
  methods: {
    isActive(item) {
      return item.match(this.path);
    },
  },
};
</script>

<style scoped>
.build-spoke-nav {
  background: var(--p-surface-elevated, #fff);
  border-bottom: 1px solid var(--p-border, #e2e8f0);
  margin: calc(-1 * var(--spacing-lg, 1.5rem)) calc(-1 * var(--spacing-lg, 1.5rem)) var(--spacing-lg, 1.5rem);
  padding: 0.5rem var(--spacing-lg, 1.5rem);
  position: sticky;
  top: 3.5rem;
  z-index: 40;
}

.spoke-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.spoke-link {
  display: inline-flex;
  align-items: center;
  padding: 0.45rem 0.75rem;
  border-radius: 0.5rem;
  color: var(--p-ink-muted, #64748b);
  font-size: 0.875rem;
  font-weight: 500;
  text-decoration: none;
}

.spoke-link:hover {
  background: var(--p-surface-muted, #f1f5f9);
  color: var(--p-ink, #1e293b);
}

.spoke-link.active {
  background: var(--p-accent-subtle, #eef2f8);
  color: var(--p-accent, #1e3a5f);
}
</style>
